/* src/app/components/doc-viewer-new/doc-viewer-bottom-right-bar/split-doc-panel/split-doc-panel.component.scss */
.form-container {
  display: flex;
  flex-direction: column;
}
.form-container > label {
  color: #3949AB;
  font-weight: 500;
  display: block;
  margin-bottom: 2px;
}
:host-context(.dark-theme) .form-container > label {
  color: #FFC107;
}
.input-container {
  display: flex;
  flex-direction: row;
  border: 1px solid #565656;
  border-radius: 5px;
  align-items: center;
}
.input-container > input,
textarea {
  width: 100%;
  appearance: none;
  outline: none;
  border: none;
  padding: 0;
  margin-left: 12px;
  background: inherit;
  color: inherit;
}
/*# sourceMappingURL=split-doc-panel.component.css.map */
